import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";

import { RunHistoryEntryType } from "../../types";

type PendingReviewEntryProps = {
  note: string | null;
  timestamp: number;
  until: number | null;
};

const PendingReviewEntry = ({ note, until, timestamp }: PendingReviewEntryProps) => {
  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.PendingReview}
      timestamp={timestamp}
      until={until}
      isLoading={!until}
    >
      <HistoryEntryNote>{note}</HistoryEntryNote>
    </HistoryEntryWrapper>
  );
};

export default PendingReviewEntry;
